import { gql } from "@apollo/client";

// Query to get all leads (visitors with name and email)
export const GET_LEADS = gql`
  query GetLeads($spaceId: ID!, $widgetId: ID, $limit: Int, $offset: Int) {
    getVisitors(
      spaceId: $spaceId
      widgetId: $widgetId
      limit: $limit
      offset: $offset
    ) {
      id
      sessionId
      name
      email
      phone
      company
      widgetId
      spaceId
      chatSessionId
      country
      city
      region
      browser
      device
      totalPageViews
      firstSeen
      lastSeen
      lastActiveAt
      isOnline
      leadStatus
      leadScore
      leadNotes {
        note
        addedBy
        addedAt
      }
      pageViews {
        url
        title
        viewedAt
        duration
      }
    }
  }
`;

// Query to get all widgets for filter dropdown
export const GET_ALL_WIDGETS = gql`
  query GetAllWidgets($spaceId: ID!) {
    getAllWidgets(spaceId: $spaceId) {
      id
      script_id
      business_details {
        display_name
      }
    }
  }
`;

// Mutation to update visitor info
export const UPDATE_VISITOR_INFO = gql`
  mutation UpdateVisitorInfo(
    $sessionId: String!
    $name: String
    $email: String
    $phone: String
    $company: String
    $chatSessionId: String
  ) {
    updateVisitorInfo(
      sessionId: $sessionId
      name: $name
      email: $email
      phone: $phone
      company: $company
      chatSessionId: $chatSessionId
    ) {
      id
      sessionId
      name
      email
      phone
      company
    }
  }
`;

// Mutation to update lead status
export const UPDATE_LEAD_STATUS = gql`
  mutation UpdateLeadStatus($sessionId: String!, $leadStatus: String!) {
    updateLeadStatus(sessionId: $sessionId, leadStatus: $leadStatus) {
      id
      sessionId
      leadStatus
    }
  }
`;

// Mutation to add a lead note
export const ADD_LEAD_NOTE = gql`
  mutation AddLeadNote($sessionId: String!, $note: String!, $addedBy: String) {
    addLeadNote(sessionId: $sessionId, note: $note, addedBy: $addedBy) {
      id
      sessionId
      leadNotes {
        note
        addedBy
        addedAt
      }
    }
  }
`;
